import { useGeneratePDF } from '@/hooks/v2/resolution-886/useGeneratePDF';

interface DownloadPDFParams {
	report: {
		id: string;
	};
	organizationId: string;
	companyId: string;
	lastReviewId: string;
}

interface GeneratePDFParameters {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	locale: string;
	include_fields: string[];
}

export const useDownloadPDF = ({ report, organizationId, companyId, lastReviewId }: DownloadPDFParams) => {
	const { isLoading: downloadPDFLoading, mutateAsync: generatePDF } = useGeneratePDF();

	const handleOnDownloadPDF = async (values: { pdf_custom?: string[]; reviewId?: string }): Promise<void> => {
		const selectedSections = values.pdf_custom || [];
		const browserLanguage = window.navigator.language ?? 'en-US';

		const reviewId = values.reviewId || lastReviewId;

		const parameters: GeneratePDFParameters = {
			organization_id: organizationId,
			company_id: companyId,
			report_id: report?.id || '',
			review_id: reviewId,
			locale: browserLanguage,
			include_fields: selectedSections
		};

		await generatePDF(parameters);
	};

	return {
		downloadPDFLoading,
		onDownloadPDF: handleOnDownloadPDF
	};
};
